import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal } from "./Reveal";
import { EQUIPOS } from "./data";
import { useContent } from "@/lib/useContent";
import { Check } from "lucide-react";

export const Equipos = () => {
  const equipos = useContent("equipos", EQUIPOS);
  const [active, setActive] = useState(null);
  const current = equipos.find((e) => e.id === active) || equipos[0];
  if (!current) return null;

  return (
    <section id="equipos" className="relative py-24 md:py-32 bg-navy text-white overflow-hidden">
      <div className="absolute -top-24 -left-24 h-72 w-72 rounded-full bg-gold/10 blur-3xl" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <Reveal className="max-w-3xl">
          <span className="section-tag section-tag--dark">Fútbol del club</span>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
            Cuatro categorías, una sola camiseta
          </h2>
          <p className="mt-5 text-lg text-white/75 leading-relaxed">
            De los más chicos a los más experimentados: el club forma y compite en todas las edades.
          </p>
        </Reveal>

        {/* Tabs */}
        <div className="mt-10 flex flex-wrap gap-2.5">
          {equipos.map((e) => (
            <button
              key={e.id}
              data-testid={`equipo-tab-${e.id}`}
              onClick={() => setActive(e.id)}
              className={`px-5 py-3 rounded-xl text-sm font-bold transition-all ${
                current.id === e.id
                  ? "bg-gold text-navy shadow-lg"
                  : "bg-white/10 text-white/80 hover:bg-white/20 border border-white/10"
              }`}
            >
              {e.name}
            </button>
          ))}
        </div>

        <AnimatePresence mode="wait">
          <motion.div
            key={current.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.4 }}
            className="mt-10 grid lg:grid-cols-2 gap-8 lg:gap-12 items-center"
          >
            <div className="relative rounded-3xl overflow-hidden border border-white/10 shadow-2xl order-2 lg:order-1">
              <img
                src={current.image_url || current.image}
                alt={current.name}
                loading="lazy"
                className="w-full h-72 sm:h-96 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/80 to-transparent" />
              <span className="absolute bottom-5 left-6 inline-flex items-center text-xs font-bold uppercase tracking-wider bg-gold text-navy px-3 py-1 rounded-full">
                {current.age}
              </span>
            </div>

            <div className="order-1 lg:order-2">
              <h3 className="text-3xl sm:text-4xl font-bold text-white" style={{ fontFamily: "Outfit" }}>
                {current.name}
              </h3>
              <p className="mt-4 text-lg text-white/80 leading-relaxed">{current.desc}</p>
              <ul className="mt-7 space-y-3">
                {current.points.map((p) => (
                  <li key={p} className="flex items-center gap-3 bg-white/5 border border-white/10 rounded-xl px-5 py-3.5">
                    <Check className="h-5 w-5 text-gold shrink-0" />
                    <span className="text-white/90 font-medium">{p}</span>
                  </li>
                ))}
              </ul>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </section>
  );
};
